// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badesul-mpe-pre-approved-installments-modal .ant-modal-body {
  max-height: 70vh;
  overflow: auto;
}
.badesul-mpe-pre-approved-button-to-show {
  display: flex;
  justify-content: center;
}
.badesul-mpe-pre-approved-button-to-show span {
  color: var(--primary-button-color);
}
.badesul-mpe-pre-approved-disclaimer {
  padding-top: 0.5rem;
  padding-left: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/screens/PreApprovedScreen/components/BadesulMPEPreApproved/styles.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;EACA,cAAA;AAAJ;AAIA;EACE,aAAA;EACA,uBAAA;AAFF;AAAA;EAII,kCAAA;AADJ;AAKA;EACE,mBAAA;EACA,kBAAA;AAHF","sourcesContent":[".badesul-mpe-pre-approved-installments-modal {\n  .ant-modal-body {\n    max-height: 70vh;\n    overflow: auto;\n  }\n}\n\n.badesul-mpe-pre-approved-button-to-show {\n  display: flex;\n  justify-content: center;\n  span {\n    color: var(--primary-button-color);\n  }\n}\n\n.badesul-mpe-pre-approved-disclaimer {\n  padding-top: 0.5rem;\n  padding-left: 1rem;\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
